import styled from 'styled-components'

export const HomeVideoTitle = styled.p`
  color: ${props => (props.textColor ? '#181818' : '#f9f9f9')};
  font-size: 16px;
  font-family: 'Roboto';
  font-weight: 600;
`
